export default {"src":"/pro/_next/static/media/link.e9650ffb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};